import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinningLoaderComponent } from '@pc/spinning-loader';
import { ProcessTypeStore } from '../../store/process-type-store/process-type-store';
import { AnimationDialogService } from '@pc/dialog-abstract';
import { DialogRef } from '@angular/cdk/dialog';
import { Translations } from '../../shared/services/translations.service';
import { TranslateModule } from '@ngx-translate/core';
import { EnvironmentService } from '../../environment/environment.service';

@Component({
  selector: 'pc-spinning-loader-card',
  standalone: true,
  imports: [CommonModule, TranslateModule, SpinningLoaderComponent],
  templateUrl: './spinning-loader-card.component.html',
  styleUrl: './spinning-loader-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinningLoaderCardComponent {
  public isActive = computed(() => this.processTypeStore.isLoading() || !this.processReady());
  public translations = inject(Translations);

  private processTypeStore = inject(ProcessTypeStore);
  private env = inject(EnvironmentService);
  private processReady = computed(() => this.env.isActive() !== null);
  private animationDialogService = inject(AnimationDialogService);
  private dialogRef = inject(DialogRef);

  constructor() {
    effect(() => {
      if (!this.isActive() || this.processTypeStore.apiError()) {
        this.animationDialogService.closeDialogWithAnimation(this.dialogRef);
      }
    });
  }
}
